const WebcamTurnedOff = () => {
  return(
    <div className="rounded-lg bg-bg-2 m-4 shadow-2xl p-10 md:p-20 text-sm sm:text-xl text-gray-600">
      Webcam Turned Off
    </div>
  );
};

export default WebcamTurnedOff;